import React from 'react'
import styled from 'styled-components'
import { IconButton } from '@material-ui/core'
import { IconButtonProps } from '@material-ui/core/IconButton'
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'

const IconButtonStyled = styled(IconButton)`
  padding: 5px;
  margin-left: auto;
` as React.ComponentType<IconButtonProps>

export const ArrowIcon = ({ up, ...rest }) => (
  <IconButtonStyled>
    {up ? <ArrowDropUp {...rest} /> : <ArrowDropDown {...rest} />}
  </IconButtonStyled>
)
